import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Auth from "../../utils/AuthUtils";
import userAPI from "../../api/UserApi";
import { getTimeAgo } from "../../helper/Helper";

import {
  ShoppingBag,
  ArrowRight,
  Clock3,
  IndianRupee,
  PackageCheck,
} from "lucide-react";

function Dashboard() {
  const { username } = Auth.getToken();

  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchLatestOrder();
  }, []);

  const fetchLatestOrder = async () => {
    try {
      const res = await userAPI.fetchLatestOrder();

      if (res.code === 200) {
        const result = res.data;

        setOrders(result);
      }
    } catch (err) {}
  };

  return (
    <div className="custom-account-dashboard">

      {/* =====================================
          WELCOME HEADER
      ===================================== */}

      <div className="custom-account-header">

        <div className="custom-account-welcome">

          <span className="custom-account-eyebrow">
            MY ACCOUNT
          </span>

          <h4 className="custom-hello-text">
            Hello, {username}
          </h4>

          <p className="custom-account-desc">
            Welcome back. Manage your orders, account details
            and everything related to your shopping experience.
          </p>

        </div>

        <Link
          to="/shop"
          className="custom-dashboard-shop-btn"
        >
          Continue Shopping
          <ArrowRight size={16} />
        </Link>

      </div>


      {/* =====================================
          QUICK LINKS
      ===================================== */}

      <div className="custom-dashboard-quick-links">

        <NavLink
          to="/users/orders"
          className="custom-quick-link"
        >
          <span className="custom-quick-icon">
            <ShoppingBag size={18} />
          </span>

          <span>
            <strong>My Orders</strong>
            <small>View order history</small>
          </span>

          <ArrowRight size={16} />
        </NavLink>


        <NavLink
          to="/users/account"
          className="custom-quick-link"
        >
          <span className="custom-quick-icon">
            <PackageCheck size={18} />
          </span>

          <span>
            <strong>Account Details</strong>
            <small>Manage your profile</small>
          </span>

          <ArrowRight size={16} />
        </NavLink>

      </div>


      {/* =====================================
          LATEST ORDER
      ===================================== */}

      <div className="custom-latest-order-section">

        <div className="custom-dashboard-section-heading">

          <div>
            <span>LATEST ACTIVITY</span>
            <h5>Recent Order</h5>
          </div>

          <Link
            to="/users/orders"
            className="custom-dashboard-view-all"
          >
            View all
            <ArrowRight size={15} />
          </Link>

        </div>


        {orders ? (

          <div className="custom-order-card">

            {/* Order Header */}

            <div className="custom-order-header">

              <div className="custom-order-number">

                <div className="custom-order-icon">
                  <ShoppingBag size={19} />
                </div>

                <div>
                  <span>ORDER</span>

                  <strong>
                    #{orders?.orderId}
                  </strong>
                </div>

              </div>


              <div className="custom-order-status">
                <span className="custom-status-dot"></span>

                {orders?.status}
              </div>

            </div>


            {/* Order Details */}

            <div className="custom-order-body">

              <div className="custom-order-info">

                <div className="custom-order-info-icon">
                  <Clock3 size={17} />
                </div>

                <div>
                  <span>ORDER DATE</span>

                  <strong>
                    {getTimeAgo(orders?.createdAt)}
                  </strong>
                </div>

              </div>


              <div className="custom-order-info">

                <div className="custom-order-info-icon">
                  <IndianRupee size={17} />
                </div>

                <div>
                  <span>ORDER TOTAL</span>

                  <strong>
                    ₹{orders?.total}/-
                  </strong>
                </div>

              </div>


              <Link
                to="/users/orders"
                className="custom-order-view-btn"
              >
                View Order
                <ArrowRight size={15} />
              </Link>

            </div>

          </div>

        ) : (

          <Link
            to="/users/orders"
            className="custom-empty-card"
          >

            <div className="custom-empty-icon">
              <ShoppingBag size={24} />
            </div>

            <div>
              <h5>No orders yet</h5>

              <p>
                Your recent orders will appear here.
              </p>
            </div>

            <ArrowRight size={18} />

          </Link>

        )}

      </div>

    </div>
  );
}

export default Dashboard;